import React, { useEffect, useRef, useState } from "react";
// import "./Personal.css";
import { Check, Copy, Plus, X, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import InnerHeader from "../../components/InnerHeader";

export default function Personal() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("personal");
  const apiBase = process.env.REACT_APP_API_URL;

  const [userData, setUserData] = useState({
    username: "",
    vip_coin: 0,
    name: "",
    phone: "",
    session_id: "",
    email: "",
    created_at: "",
    dofb: "",
    email_verified_at: null,
  });

  const [isEditingBirthday, setIsEditingBirthday] = useState(false);
  const [dofb, setDofb] = useState("");
  const [profileLoaded, setProfileLoaded] = useState(false);

  const [verifyType, setVerifyType] = useState("");
  const [timer, setTimer] = useState(0);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [getotherContracts, setotherContracts] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [isEditingName, setIsEditingName] = useState(false);
  const [nameInput, setNameInput] = useState("");
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [emailInput, setEmailInput] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("error");

  const countdownRef = useRef(null);

  const token = localStorage.getItem("token");
  const remoteId = localStorage.getItem("remote_id");

  const showMsg = (message, type = "error") => {
    setModalMessage(message);
    setModalType(type || "error");
    setShowModal(true);
  };

  const clearCountdown = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
  };

  const resetVerificationState = () => {
    clearCountdown();
    setTimer(0);
    setIsCodeSent(false);
    setIsButtonDisabled(false);
    setVerificationCode("");
  };

  const startCountdown = () => {
    clearCountdown();
    setIsCodeSent(true);
    setIsButtonDisabled(true);
    setTimer(5 * 60);

    countdownRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearCountdown();
          setIsCodeSent(false);
          setIsButtonDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const fetchUserData = async () => {
    if (token && remoteId) {
      try {
        const response = await fetch(
          `${apiBase}/api/user/show?remote_id=${remoteId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          const formattedDate = data.created_at
            ? new Date(data.created_at).toLocaleDateString("en-GB")
            : "N/A";

          setUserData({
            username: data.username || "Unknown User",
            vip_coin: data.vip_coin || 0,
            name: data.name || "N/A",
            phone: data.phone || "",
            email: data.email || "",
            session_id: data.session_id || "",
            created_at: formattedDate,
            dofb: data.dofb || "",
            email_verified_at: data.email_verified_at || null,
          });

          setDofb(data.dofb || "");
          setIsEditingBirthday(!data.dofb);

          if (!data.name) {
            setIsEditingName(true);
          }
          if (!data.email) {
            setIsEditingEmail(true);
          }

          setNameInput(data.name || "");
          setEmailInput(data.email || "");
          setProfileLoaded(true);
        } else {
          showMsg("Failed to fetch user data");
        }
      } catch (error) {
        showMsg("Error fetching user data");
      }
    }
  };

  const updateProfileField = async (payload) => {
    if (!token || !remoteId) {
      return { ok: false, message: "Not authenticated" };
    }

    try {
      const response = await fetch(`${apiBase}/api/user/profile/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ remote_id: remoteId, ...payload }),
      });

      const data = await response.json().catch(() => ({}));
      return {
        ok: response.ok,
        data,
        message: data?.message || data?.error,
      };
    } catch (e) {
      return { ok: false, message: "Network error" };
    }
  };

  const saveNameOnce = async () => {
    if (!nameInput || nameInput.trim().length < 2) {
      showMsg("Please enter a valid full name.");
      return;
    }

    const res = await updateProfileField({ name: nameInput.trim() });

    if (res.ok) {
      await fetchUserData();
      setIsEditingName(false);
      showMsg("Full name updated successfully.", "success");
    } else {
      showMsg(res.message || "Failed to update name");
    }
  };

  const saveEmailOnce = async () => {
    const email = emailInput.trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) {
      showMsg("Please enter a valid email address.");
      return;
    }

    const res = await updateProfileField({ email });

    if (res.ok) {
      await fetchUserData();
      setIsEditingEmail(false);
      showMsg("Email updated. Please verify your email.", "success");
      OpenPOP("email");
    } else {
      showMsg(res.message || "Failed to update email");
    }
  };

  const fetchOther = async () => {
    if (token) {
      try {
        const response = await fetch(`${apiBase}/api/get/other/phone`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setotherContracts(Array.isArray(data?.data) ? data.data : []);
        } else {
          showMsg("Failed to fetch other contacts");
        }
      } catch (error) {
        showMsg("Error fetching other contacts");
      }
    }
  };

  const updateDofb = async () => {
    if (!token || !remoteId) {
      showMsg("Not authenticated");
      return;
    }

    if (userData.dofb) {
      showMsg("Date of birth can only be updated one time.");
      setIsEditingBirthday(false);
      setDofb(userData.dofb);
      return;
    }

    if (!dofb) {
      showMsg("Please select your date of birth.");
      return;
    }

    try {
      const response = await fetch(`${apiBase}/api/user/profile/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          remote_id: remoteId,
          dofb,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        const savedDofb = data.dofb || dofb;

        setUserData((prevUserData) => ({
          ...prevUserData,
          dofb: savedDofb,
        }));

        setDofb(savedDofb);
        setIsEditingBirthday(false);
        showMsg("Birthday updated successfully. You cannot change it again.", "success");
      } else {
        showMsg(data?.message || "Failed to update birthday");
      }
    } catch (error) {
      showMsg("Error updating birthday");
    }
  };

  const verfiyPhoneNumber = async () => {
    if (!token) return false;

    try {
      const response = await fetch(`${apiBase}/api/verify-phone-number`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          verification_code: verificationCode,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        await fetchUserData();
        await fetchOther();
        showMsg(data?.message || "Phone verified successfully.", "success");
        return true;
      } else {
        showMsg(data?.message || "Failed to verify phone");
        return false;
      }
    } catch (error) {
      showMsg("Error verifying phone");
      return false;
    }
  };

  const verfiyEmail = async () => {
    if (!token) return false;

    try {
      const response = await fetch(`${apiBase}/api/verify-email`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: verificationCode,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        await fetchUserData();
        await fetchOther();
        showMsg(data?.message || "Email verified successfully.", "success");
        return true;
      } else {
        showMsg(data?.message || "Failed to verify email");
        return false;
      }
    } catch (error) {
      showMsg("Error verifying email");
      return false;
    }
  };

  const addverfiyPhoneNumber = async () => {
    if (!token) return false;

    try {
      const response = await fetch(`${apiBase}/api/add/verify-phone-number`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          verification_code: verificationCode,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        await fetchUserData();
        await fetchOther();
        setPhoneNumber("");
        showMsg(data?.message || "New phone added successfully.", "success");
        return true;
      } else {
        showMsg(data?.message || "Failed to verify new phone");
        return false;
      }
    } catch (error) {
      showMsg("Error verifying new phone");
      return false;
    }
  };

  const verfiyPhonCode = async () => {
    if (isButtonDisabled || !token) return;

    try {
      const response = await fetch(`${apiBase}/api/send-verification-code`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone: userData.phone,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        startCountdown();
      } else {
        showMsg(data?.message || "Failed to send phone code");
      }
    } catch (error) {
      showMsg("Error sending phone code");
    }
  };

  const verfiyEmailCode = async () => {
    if (isButtonDisabled || !token) return;

    try {
      const response = await fetch(`${apiBase}/api/send-verification-code`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userData.email,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        startCountdown();
      } else {
        showMsg(data?.message || "Failed to send email code");
      }
    } catch (error) {
      showMsg("Error sending email code");
    }
  };

  const addPhoneNumber = async () => {
    if (isButtonDisabled || !token) return;

    if (!phoneNumber.trim()) {
      showMsg("Please enter a phone number.");
      return;
    }

    try {
      const response = await fetch(`${apiBase}/api/add/number`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phone: phoneNumber }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        showMsg(data?.message || "Failed to add phone number");
        return;
      }

      const verifyResponse = await fetch(
        `${apiBase}/api/add/send-verification-code`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ phone: phoneNumber }),
        }
      );

      const verifyData = await verifyResponse.json().catch(() => ({}));

      if (!verifyResponse.ok) {
        showMsg(verifyData?.message || "Failed to send verification code");
        return;
      }

      startCountdown();
      showMsg("Verification code sent successfully.", "success");
    } catch (error) {
      showMsg("Error sending verification code");
    }
  };

  useEffect(() => {
    fetchUserData();
    fetchOther();

    return () => {
      clearCountdown();
    };
  }, []);

  const OpenPOP = (type) => {
    resetVerificationState();
    setVerifyType(type);
  };

  const ClosePOP = () => {
    setVerifyType("");
    resetVerificationState();
    setPhoneNumber("");
  };

  const handleVerifySubmit = async () => {
    let success = false;

    if (verifyType === "email") {
      success = await verfiyEmail();
    } else if (verifyType === "unverifiedphone") {
      success = await verfiyPhoneNumber();
    } else if (verifyType === "phone") {
      success = await addverfiyPhoneNumber();
    }

    if (success) {
      ClosePOP();
    }
  };

  const handleSendCode = async () => {
    if (verifyType === "email") {
      await verfiyEmailCode();
    } else if (verifyType === "unverifiedphone") {
      await verfiyPhonCode();
    } else if (verifyType === "phone") {
      await addPhoneNumber();
    }
  };

  const handleCopy = async (text) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      showMsg("Copied successfully.", "success");
    } catch {
      showMsg("Failed to copy");
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("remote_id");
    navigate("/login");
  };

  const mainPhoneVerified =
    String(userData.session_id) === "1" || userData.session_id === 1;

  const otherPhoneContracts = (getotherContracts || []).filter(
    (contract, index, arr) =>
      contract?.contract_value &&
      contract.contract_value !== userData.phone &&
      arr.findIndex(
        (item) => item?.contract_value === contract?.contract_value
      ) === index
  );

  const canAddMorePhones = otherPhoneContracts.length < 2;
  const birthdayLocked = Boolean(userData.dofb);

  const renderVerifyPopup = () => {
    if (!verifyType) return null;

    const isEmail = verifyType === "email";
    const isNewPhone = verifyType === "phone";
    const title = isEmail
      ? "Verify Email"
      : isNewPhone
      ? "Add New Phone"
      : "Verify Phone";

    return (
      <div style={popupOverlayStyle} onClick={ClosePOP}>
        <div style={popupCardStyle} onClick={(e) => e.stopPropagation()}>
          <button type="button" style={closeBtnStyle} onClick={ClosePOP}>
            <X size={18} />
          </button>

          <h3 style={{ margin: "0 0 16px", color: "#fff" }}>{title}</h3>

          <div style={{ display: "grid", gap: 12 }}>
            {isEmail && (
              <input
                value={userData.email || ""}
                readOnly
                style={popupInputStyle}
                placeholder="Email"
              />
            )}

            {!isEmail && !isNewPhone && (
              <input
                value={userData.phone || ""}
                readOnly
                style={popupInputStyle}
                placeholder="Phone"
              />
            )}

            {isNewPhone && (
              <input
                value={phoneNumber}
                onChange={(e) =>
                  setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))
                }
                style={popupInputStyle}
                placeholder="Enter new phone number"
              />
            )}

            <div style={{ display: "flex", gap: 8 }}>
              <input
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                style={{ ...popupInputStyle, flex: 1 }}
                placeholder="Input verification code"
              />

              <button
                type="button"
                onClick={handleSendCode}
                disabled={isButtonDisabled}
                style={{
                  ...sendCodeBtnStyle,
                  opacity: isButtonDisabled ? 0.7 : 1,
                  cursor: isButtonDisabled ? "not-allowed" : "pointer",
                }}
              >
                {isCodeSent
                  ? `${Math.floor(timer / 60)}:${
                      timer % 60 < 10 ? `0${timer % 60}` : timer % 60
                    }`
                  : "Verify"}
              </button>
            </div>

            <button
              type="button"
              onClick={handleVerifySubmit}
              style={submitPopupBtnStyle}
            >
              {isNewPhone ? "Add" : "Submit"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="profile-app">
      <InnerHeader title="Profile" />

      <div className="profile-tabs">
        <div className="profile-list" style={{ width: "100%" }}>
          <div className="row">
            <span className="label">Username</span>
            <span className="right">
              <span className="value edit-rep">{userData.username}</span>
              <Copy
                size={16}
                color="#8d9aa5"
                style={{ cursor: "pointer" }}
                onClick={() => handleCopy(userData.username)}
              />
            </span>
          </div>

          <div className="row" style={{ alignItems: "flex-start" }}>
            <span className="label">Full legal name</span>

            <span className="right column" style={{ alignItems: "flex-end" }}>
              <span
                style={{
                  fontSize: 12,
                  color: "#8d9aa5",
                  marginBottom: 8,
                }}
              >
                Date Registered: {userData.created_at}
              </span>

              {profileLoaded &&
              (!userData.name || userData.name === "N/A") &&
              isEditingName ? (
                <div style={{ width: "100%", maxWidth: 240 }}>
                  <input
                    type="text"
                    className="personal-number"
                    value={nameInput}
                    onChange={(e) => setNameInput(e.target.value)}
                    placeholder="Full Name"
                    style={{ width: "100%" }}
                  />

                  <div
                    className="button"
                    onClick={saveNameOnce}
                    style={{ marginTop: 8 }}
                  >
                    Save
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                  }}
                >
                  <span className="value edit-rep">
                    {userData.name || "N/A"}
                  </span>
                  {userData.name && userData.name !== "N/A" && (
                    <Copy
                      size={16}
                      color="#8d9aa5"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleCopy(userData.name)}
                    />
                  )}
                  {(!userData.name || userData.name === "N/A") && (
                    <button
                      type="button"
                      onClick={() => setIsEditingName(true)}
                      style={miniActionBtn}
                    >
                      Edit
                    </button>
                  )}
                </div>
              )}
            </span>
          </div>

          <div className="row">
            <span className="label">Date of birth</span>

            <div
              className="right"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                justifyContent: "flex-end",
                flexWrap: "wrap",
              }}
            >
              <input
                type="date"
                disabled={birthdayLocked}
                className="inns"
                value={birthdayLocked ? userData.dofb : dofb}
                onChange={(e) => setDofb(e.target.value)}
                style={{
                  maxWidth: 170,
                  opacity: birthdayLocked ? 0.8 : 1,
                }}
              />

              {birthdayLocked ? (
                <span style={lockedBadgeStyle}>
                  <Lock size={13} />
                  Locked
                </span>
              ) : (
                <button
                  type="button"
                  onClick={updateDofb}
                  style={miniActionBtn}
                >
                  Save
                </button>
              )}
            </div>
          </div>

          <div className="row" style={{ alignItems: "flex-start" }}>
            <span className="label">Phone</span>

            <div
              className="right column"
              style={{ alignItems: "stretch", gap: 8, minWidth: 220 }}
            >
              <div style={contactCardStyle}>
                <div style={contactTextStyle}>{userData.phone || "-"}</div>
                <div style={contactActionStyle}>
                  {mainPhoneVerified ? (
                    <span style={verifiedBadgeStyle}>
                      <Check size={14} />
                      Verified
                    </span>
                  ) : (
                    <button
                      type="button"
                      style={unverifiedBtnStyle}
                      onClick={() => OpenPOP("unverifiedphone")}
                    >
                      Not Verified
                    </button>
                  )}
                </div>
              </div>

              {otherPhoneContracts.map((contract) => (
                <div
                  key={contract.id || contract.contract_value}
                  style={contactCardStyle}
                >
                  <div style={contactTextStyle}>
                    {contract.contract_value || "-"}
                  </div>
                  <div style={contactActionStyle}>
                    {Number(contract.isverify) === 1 ? (
                      <span style={verifiedBadgeStyle}>
                        <Check size={14} />
                        Verified
                      </span>
                    ) : (
                      <span style={pendingBadgeStyle}>Not Verified</span>
                    )}
                  </div>
                </div>
              ))}

              {canAddMorePhones && (
                <button
                  type="button"
                  onClick={() => OpenPOP("phone")}
                  style={addContactBtnStyle}
                >
                  <Plus size={16} />
                  Add Phone
                </button>
              )}
            </div>
          </div>

          <div className="row" style={{ alignItems: "flex-start" }}>
            <span className="label">Email</span>

            <div
              className="right column"
              style={{ alignItems: "stretch", gap: 8, minWidth: 220 }}
            >
              {profileLoaded && (!userData.email || isEditingEmail) ? (
                <div style={{ width: "100%" }}>
                  <input
                    type="email"
                    className="personal-number"
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                    placeholder="Enter your email"
                    style={{ width: "100%" }}
                  />
                  <div
                    className="button"
                    onClick={saveEmailOnce}
                    style={{ marginTop: 8 }}
                  >
                    Save
                  </div>
                </div>
              ) : (
                <div style={contactCardStyle}>
                  <div style={contactTextStyle}>{userData.email || "-"}</div>
                  <div style={contactActionStyle}>
                    {userData.email_verified_at ? (
                      <span style={verifiedBadgeStyle}>
                        <Check size={14} />
                        Verified
                      </span>
                    ) : (
                      <button
                        type="button"
                        style={unverifiedBtnStyle}
                        onClick={() => OpenPOP("email")}
                      >
                        Not Verified
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {renderVerifyPopup()}

      {showModal && (
        <div style={popupOverlayStyle} onClick={() => setShowModal(false)}>
          <div style={modalCardStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                fontSize: 18,
                fontWeight: 700,
                marginBottom: 12,
                color:
                  modalType === "success"
                    ? "#22c55e"
                    : modalType === "info"
                    ? "#3b82f6"
                    : "#ef4444",
              }}
            >
              {modalType === "success"
                ? "Success"
                : modalType === "info"
                ? "Notice"
                : "Error"}
            </div>

            <div
              style={{ color: "#fff", lineHeight: 1.6, marginBottom: 16 }}
              dangerouslySetInnerHTML={{ __html: modalMessage }}
            />

            <button
              type="button"
              onClick={() => setShowModal(false)}
              style={submitPopupBtnStyle}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const miniActionBtn = {
  border: "none",
  background: "#1e88e5",
  color: "#fff",
  padding: "6px 10px",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 12,
  fontWeight: 600,
};

const contactCardStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
  padding: "10px 12px",
  borderRadius: 12,
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
};

const contactTextStyle = {
  color: "#e5e7eb",
  fontSize: 14,
  wordBreak: "break-word",
};

const contactActionStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  flexShrink: 0,
};

const verifiedBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  background: "rgba(34,197,94,0.12)",
  color: "#22c55e",
  border: "1px solid rgba(34,197,94,0.25)",
  padding: "5px 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 700,
};

const pendingBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  background: "rgba(245,158,11,0.12)",
  color: "#f59e0b",
  border: "1px solid rgba(245,158,11,0.25)",
  padding: "5px 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 700,
};

const lockedBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  background: "rgba(148,163,184,0.12)",
  color: "#cbd5e1",
  border: "1px solid rgba(148,163,184,0.25)",
  padding: "5px 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 700,
};

const unverifiedBtnStyle = {
  border: "none",
  background: "rgba(239,68,68,0.12)",
  color: "#ef4444",
  borderRadius: 999,
  padding: "6px 10px",
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
};

const addContactBtnStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  border: "1px dashed rgba(255,255,255,0.2)",
  background: "transparent",
  color: "#8d9aa5",
  borderRadius: 12,
  padding: "10px 12px",
  cursor: "pointer",
  fontWeight: 600,
};

const popupOverlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  padding: 16,
};

const popupCardStyle = {
  position: "relative",
  width: "100%",
  maxWidth: 420,
  background: "#111827",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: 18,
  padding: 20,
  boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
};

const modalCardStyle = {
  width: "100%",
  maxWidth: 360,
  background: "#111827",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: 18,
  padding: 20,
};

const closeBtnStyle = {
  position: "absolute",
  top: 12,
  right: 12,
  background: "transparent",
  border: "none",
  color: "#9ca3af",
  cursor: "pointer",
};

const popupInputStyle = {
  width: "100%",
  background: "#0b1220",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: 12,
  color: "#fff",
  padding: "12px 14px",
  outline: "none",
};

const sendCodeBtnStyle = {
  minWidth: 92,
  border: "none",
  background: "#1d4ed8",
  color: "#fff",
  borderRadius: 12,
  padding: "0 12px",
  cursor: "pointer",
  fontWeight: 700,
};

const submitPopupBtnStyle = {
  width: "100%",
  border: "none",
  background: "#f59e0b",
  color: "#111827",
  borderRadius: 12,
  padding: "12px 14px",
  cursor: "pointer",
  fontWeight: 800,
  fontSize: 14,
};